import React from "react";
import formateText from "../../../utils/Formate";
import { Link, useLocation } from "react-router-dom";
import { usePermission } from "../../../context/PermissionContext";
import { screenCodeFromPath } from "../../../utils/permissionScreens";

const SubmitBtn = ({ text, onClick, styleClass, page, type, routeing,route }) => {
  const location = useLocation();
  const { canCreate, canEdit } = usePermission();
  const permissionScreen = screenCodeFromPath(location.pathname);
  const label = String(text || "").toLowerCase();
  if (permissionScreen && label === "create" && !canCreate(permissionScreen)) {
    return null;
  }
  if (permissionScreen && label === "update" && !canEdit(permissionScreen)) {
    return null;
  }
  if (permissionScreen && label === "save" && !canEdit(permissionScreen) && !canCreate(permissionScreen)) {
    return null;
  }
  const background =
    page === "agentDashboard"
      ? "bg-orange-600"
      : "bg-orange-600 hover:bg-orange-700";
  return routeing ? (
    <Link to={route}> <button
      type="button"
      onClick={onClick}
      className={`font-medium mt-4 text-sm ${
        text === "Cancel" ? " bg-red-600 ml-4" : background
      } rounded-xl h-10 px-4 text-white ${styleClass}`}
    >
      {formateText(text)}
    </button></Link>
  ) : (
    <button
      type={text === "Cancel" || type === "button" ? "button" : "submit"}
      onClick={onClick}
      className={`font-medium text-sm ${
        text === "Cancel" ? " bg-red-600 ml-4" : background
      } rounded-xl h-10 px-4 mt-4 text-white ${styleClass}`}
    >
      {formateText(text)}
    </button>
  );
};

export default SubmitBtn;
